/* eslint-disable */
import React from 'react';
import Calendar from '../../component/Inc/Calendar';
import { Link } from 'react-router-dom';
import 'contents/assets/scss/page/teacher.scss';

function TeacherStatistics() {
  return (
    <main className="com_container p_teacher_statistics">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu2_4 active">배정관리 통계</h2>
          <div className="com_btn_wrap">
            <Link to="/Teacher/Statistics/Assignment" className="com_btn gray s">배정제한 교사</Link>
            <button className="com_btn orange s btn_plus">교사 등록</button>
          </div>
        </section>
        <section className="com_pg_container">
          <div className="box full">
            <div className="com_board_list__top">
								{/* 20250218 퍼블 수정 */}
              <select className="select">
                <option>본사</option>
              </select>
              <Calendar />
            </div>
            <table className="com_board_list pick_list">
              <colgroup>
                <col width="auto" />
                <col width="10.2%" />
                <col width="10.2%" />
                <col width="10.2%" />
                <col width="10.2%" />
                <col width="10.2%" />
                <col width="10.2%" />
                <col width="10.2%" />
                <col width="10.2%" />
                <col width="10.2%" />
              </colgroup>
              <thead>
                <tr>
                  <th>구분</th>
                  <th>등록</th>
                  <th>인계</th>
                  <th>중단</th>
                  <th>종료</th>
                  <th>취소</th>
                  <th>배정완료</th>
                  <th>첫 수업 준비</th>
                  <th>1기</th>
                  <th>2기</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="bg_col">전체</td>
                  <td>
                    300
                    <br /> (368T)
                  </td>
                  <td>
                    18 <br />
                    (20T)
                  </td>
                  <td>
                    1<br /> (2T) <span className="com_red_txt">0.3%</span>
                  </td>
                  <td>
                    300
                    <br />
                    (368T)<span className="com_red_txt">0.3%</span>
                  </td>
                  <td>
                    8 <br />
                    (8T)
                  </td>
                  <td>294</td>
                  <td>45</td>
                  <td>45</td>
                  <td>65</td>
                </tr>
                <tr>
                  <td className="bg_col">국어</td>
                  <td>
                    300
                    <br /> (368T)
                  </td>
                  <td>
                    18 <br />
                    (20T)
                  </td>
                  <td>
                    1<br /> (2T) <span className="com_red_txt">0.3%</span>
                  </td>
                  <td>
                    300
                    <br />
                    (368T)<span className="com_red_txt">0.3%</span>
                  </td>
                  <td>
                    8 <br />
                    (8T)
                  </td>
                  <td>294</td>
                  <td>45</td>
                  <td>45</td>
                  <td>65</td>
                </tr>
                <tr>
                  <td className="bg_col">영어</td>
                  <td>
                    300
                    <br /> (368T)
                  </td>
                  {/* 선택시 */}
                  <td className="selected">
                    18 <br />
                    (20T)
                  </td>
                  <td>
                    1<br /> (2T) <span className="com_red_txt">0.3%</span>
                  </td>
                  <td>
                    300
                    <br />
                    (368T)<span className="com_red_txt">0.3%</span>
                  </td>
                  <td>
                    8 <br />
                    (8T)
                  </td>
                  <td>294</td>
                  <td>45</td>
                  <td>45</td>
                  <td>65</td>
                </tr>
                <tr>
                  <td className="bg_col">수학</td>
                  <td>
                    300
                    <br /> (368T)
                  </td>
                  <td>
                    18 <br />
                    (20T)
                  </td>
                  <td>
                    1<br /> (2T) <span className="com_red_txt">0.3%</span>
                  </td>
                  <td>
                    300
                    <br />
                    (368T)<span className="com_red_txt">0.3%</span>
                  </td>
                  <td>
                    8 <br />
                    (8T)
                  </td>
                  <td>294</td>
                  <td>45</td>
                  <td>45</td>
                  <td>65</td>
                </tr>
                <tr>
                  <td className="bg_col">과탐</td>
                  <td>
                    300
                    <br /> (368T)
                  </td>
                  <td>
                    18 <br />
                    (20T)
                  </td>
                  <td>
                    1<br /> (2T) <span className="com_red_txt">0.3%</span>
                  </td>
                  <td>
                    300
                    <br />
                    (368T)<span className="com_red_txt">0.3%</span>
                  </td>
                  <td>
                    8 <br />
                    (8T)
                  </td>
                  <td>294</td>
                  <td>45</td>
                  <td>45</td>
                  <td>65</td>
                </tr>
                <tr>
                  <td className="bg_col">사탐</td>
                  <td>
                    300
                    <br /> (368T)
                  </td>
                  <td>
                    18 <br />
                    (20T)
                  </td>
                  <td>
                    1<br /> (2T) <span className="com_red_txt">0.3%</span>
                  </td>
                  <td>
                    300
                    <br />
                    (368T)<span className="com_red_txt">0.3%</span>
                  </td>
                  <td>
                    8 <br />
                    (8T)
                  </td>
                  <td>294</td>
                  <td>45</td>
                  <td>45</td>
                  <td>65</td>
                </tr>
                <tr>
                  <td className="bg_col">논술</td>
                  <td>
                    300
                    <br /> (368T)
                  </td>
                  <td>
                    18 <br />
                    (20T)
                  </td>
                  <td>
                    1<br /> (2T) <span className="com_red_txt">0.3%</span>
                  </td>
                  <td>
                    300
                    <br />
                    (368T)<span className="com_red_txt">0.3%</span>
                  </td>
                  <td>
                    8 <br />
                    (8T)
                  </td>
                  <td>294</td>
                  <td>45</td>
                  <td>45</td>
                  <td>65</td>
                </tr>
                <tr>
                  <td className="bg_col">면접</td>
                  <td>
                    300
                    <br /> (368T)
                  </td>
                  <td>
                    18 <br />
                    (20T)
                  </td>
                  <td>
                    1<br /> (2T) <span className="com_red_txt">0.3%</span>
                  </td>
                  <td>
                    300
                    <br />
                    (368T)<span className="com_red_txt">0.3%</span>
                  </td>
                  <td>
                    8 <br />
                    (8T)
                  </td>
                  <td>294</td>
                  <td>45</td>
                  <td>45</td>
                  <td>65</td>
                </tr>
                <tr>
                  <td className="bg_col">생디</td>
                  <td>
                    300
                    <br /> (368T)
                  </td>
                  <td>
                    18 <br />
                    (20T)
                  </td>
                  <td>
                    1<br /> (2T) <span className="com_red_txt">0.3%</span>
                  </td>
                  <td>
                    300
                    <br />
                    (368T)<span className="com_red_txt">0.3%</span>
                  </td>
                  <td>
                    8 <br />
                    (8T)
                  </td>
                  <td>294</td>
                  <td>45</td>
                  <td>45</td>
                  <td>65</td>
                </tr>
              </tbody>
            </table>
            <hr className="com_divider" />
            <div className="com_board_list__top">
              <div className="com_board_search end">
                <article className="search">
                  <input type="search" placeholder="검색할 내용을 입력해 주세요." className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </div>
            </div>
            {/* 위의 표에서 클릭한 항목 표시*/}
            <table className="com_board_list">
              <colgroup>
                <col width="auto" />
                <col width="9.6%" />
                <col width="9.6%" />
                <col width="9.6%" />
                <col width="9.6%" />
                <col width="9.6%" />
                <col width="9.6%" />
                <col width="9.6%" />
                <col width="9.6%" />
                <col width="9.6%" />
                <col width="9.6%" />
              </colgroup>
              <thead>
                <tr>
                  <th>No.</th>
                  <th>영역</th>
                  <th>학생명</th>
                  <th>교사</th>
                  <th>담임</th>
                  <th>상태</th>
                  <th>수업 진행 수</th>
                  <th>수업 (T / 기수)</th>
                  <th>주소</th>
                  <th>배정일</th>
                  <th>수업진행변경</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>국어</td>
                  <td>
                    <button className="btn_link">김학생103</button>
                  </td>
                  <td>
                    <button className="btn_link">김교사102</button>
                  </td>
                  <td>
                    <button className="btn_link">김담임120</button>
                  </td>
                  <td>첫수업</td>
                  <td>12</td>
                  <td className="bg_col">
                    <span className="com_red_txt">1T / 2기</span>
                  </td>
                  <td className="bg_col">수원시</td>
                  <td className="bg_col">2025, 08, 25</td>
                  <td className="bg_col">
                    <button className="btn_link blue">보기</button>
                  </td>
                </tr>
                <tr>
                  <td>1</td>
                  <td>국어</td>
                  <td>
                    <button className="btn_link">김학생103</button>
                  </td>
                  <td>
                    <button className="btn_link">김교사102</button>
                  </td>
                  <td>
                    <button className="btn_link">김담임120</button>
                  </td>
                  <td>첫수업</td>
                  <td>12</td>
                  <td className="bg_col">
                    <span className="com_blue_txt">1T / 2기</span>
                  </td>
                  <td className="bg_col">수원시</td>
                  <td className="bg_col">2025, 08, 25</td>
                  <td className="bg_col">
                    <button className="btn_link blue">보기</button>
                  </td>
                </tr>
                <tr>
                  <td>1</td>
                  <td>국어</td>
                  <td>
                    <button className="btn_link">김학생103</button>
                  </td>
                  <td>
                    <button className="btn_link">김교사102</button>
                  </td>
                  <td>
                    <button className="btn_link">김담임120</button>
                  </td>
                  <td>첫수업</td>
                  <td>12</td>
                  <td className="bg_col">
                    <span className="com_blue_txt">1T / 2기</span>
                  </td>
                  <td className="bg_col">수원시</td>
                  <td className="bg_col">2025, 08, 25</td>
                  <td className="bg_col">
                    <button className="btn_link blue">보기</button>
                  </td>
                </tr>
                <tr>
                  <td>1</td>
                  <td>국어</td>
                  <td>
                    <button className="btn_link">김학생103</button>
                  </td>
                  <td>
                    <button className="btn_link">김교사102</button>
                  </td>
                  <td>
                    <button className="btn_link">김담임120</button>
                  </td>
                  <td>첫수업</td>
                  <td>12</td>
                  <td className="bg_col">
                    <span className="com_blue_txt">1T / 2기</span>
                  </td>
                  <td className="bg_col">수원시</td>
                  <td className="bg_col">2025, 08, 25</td>
                  <td className="bg_col">
                    <button className="btn_link blue">보기</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>
      </div>
    </main>
  );
}

export default TeacherStatistics;
